module.exports = __webpack_public_path__ + "static/img/ewm.97565bba.jpg";